import { ID } from '@datorama/akita';
import { IEntity } from '../interfaces/models';
import { IRole } from './role.model';
import { Column, Entity } from '../entity';
import { ColumnType, LanguagePage, PageTitles } from '../interfaces/types';

export interface IUser extends IEntity {
  active: boolean;
  clientId: ID;
  roleId: ID;
  userName: string;
  roleName: string;
  role?: IRole;
}

@Entity({
  name: PageTitles.user,
  language: LanguagePage.user,
})
export class User implements IUser {
  @Column({
    type: ColumnType.string,
    table: {
      defaultPosition: 1,
    },
  })
  userName: string;

  @Column({
    type: ColumnType.string,
    isEditable: true,
    table: {
      defaultPosition: 2,
    },
  })
  roleName: string;

  @Column({
    type: ColumnType.boolean,
    isEditable: true,
    table: {
      defaultPosition: 3,
    },
  })
  active: boolean;

  id: ID;
  clientId: ID;
  roleId: ID;
  role?: IRole;
  createdAt?: Date;
  modifiedAt?: Date;
  createdBy?: string;
  modifiedBy?: string;
  href?: string;

  constructor(
    user: IUser = {
      clientId: '',
      id: '',
      createdAt: new Date(),
      modifiedAt: new Date(),
      createdBy: '',
      modifiedBy: '',
      href: null,
      userName: '',
      roleId: '',
      roleName: '',
      active: false,
    }
  ) {
    const {
      id,
      clientId,
      createdAt,
      modifiedAt,
      createdBy,
      modifiedBy,
      href,
      userName,
      roleId,
      roleName,
      active,
    } = user;

    this.id = userName ? userName.split(' ').join('') : userName;
    this.userName = userName;
    this.roleName = roleName;
    this.active = active;
    this.clientId = clientId;
    this.createdAt = createdAt;
    this.modifiedAt = modifiedAt;
    this.createdBy = createdBy;
    this.modifiedBy = modifiedBy;
    this.href = href;
    this.roleId = roleId;
  }
}
